import Event from 'base/event'
import Hub from 'base/hub'

let currentTimer = {
  addHold() {},
  removeHold() {},
  renderFinished() {},
}

class TransitionTimer {
  didRender = false
  holds = new Set()
  inTransition = true

  constructor(routeName) {
    this.routeName = routeName
  }

  addHold(hold) {
    if (!this.inTransition) return
    this.holds.add(hold)
  }

  checkFinish() {
    if (this.didRender && this.holds.size === 0) {
      this.inTransition = false
      Hub.pub(Event.App.TRANSITION_END, this)
    }
  }

  renderFinished() {
    if (!this.inTransition) return
    this.didRender = true
    this.checkFinish()
  }

  removeHold(hold) {
    if (!this.inTransition) return
    this.holds.delete(hold)
    this.checkFinish()
  }
}

Hub.sub(Event.App.TRANSITION_START, (eventName, routeName) => {
  if (currentTimer) {
    currentTimer.inTransition = false
  }

  currentTimer = new TransitionTimer(routeName)
})

Hub.sub(Event.App.TRANSITION_ADVANCE, (eventName, hold) => {
  currentTimer.removeHold(hold)
})

Hub.sub(Event.App.TRANSITION_HOLD, (eventName, hold) => {
  currentTimer.addHold(hold)
})

Hub.sub(Event.App.TRANSITION_RENDER, () => {
  currentTimer.renderFinished()
})
